import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { fb } from 'packages/client/src/app/modules/shared/shared.global-service';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../kit/action-buttons/action-buttons.component';
import { KeyWorkerStore } from './key-worker.store';
import {
    SelectUserComponent,
} from 'packages/client/src/app/modules/content/components/common/select-user/select-user.component';
import { contentGlobalSuccess } from 'packages/client/src/app/modules/content/content.error';
import { FolderGridItemObject } from '@it2go/types';
import { EmploymentParentGroupEnum } from '@libs/types/src/user/enum/employment-parent-group.enum';

@Component({
    selector: 'app-key-worker',
    templateUrl: './key-worker.component.html',
    styleUrl: './key-worker.component.scss',
    providers: [KeyWorkerStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports:
        [
            DialogModule,
            ActionButtonsComponent,
            SelectUserComponent,
        ],
})
export class KeyWorkerComponent extends BaseDialogComponent {

    protected readonly store = inject(KeyWorkerStore);

    protected serviceId: FolderGridItemObject['serviceId'] = this.dialogConfig.data.serviceId;

    protected employment = EmploymentParentGroupEnum.DIRECT_CARE;

    protected form = fb.group({
        userId: fb.control<string | null>(null),
    });

    constructor() {
        super();
        this.form.patchValue({
            userId: this.dialogConfig.data.keyWorkerId || null,
        });
    }

    protected async submit() {
        if (this.form.isInvalid()) return;

        const response = await this.store.api.patchFolder({
            id: this.dialogConfig.data.folderId,
            keyWorkerId: this.form.value.userId,
        });

        if (response) {
            contentGlobalSuccess.next('common.updated');
            this.form.reset();
            this.dialogRef.close();
        }
    }
}
